/* Custom dropdown for the shop PDP variant select (Dropdown picker_type).
   Builds a styleable trigger + popup over the native <select>, keeping the
   native element for the form value and variant logic. */
(function () {
  var CHEVRON =
    '<svg class="cs__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(select) {
    var wrap = select.closest('.select');
    if (!wrap || wrap.dataset.csReady) return;
    wrap.dataset.csReady = '1';
    wrap.classList.add('cs');

    var label = document.querySelector('label[for="' + select.id + '"]');
    var listId = select.id + '-cs-list';
    var active = -1;

    /* The trigger is the keyboard and screen reader control (select-only combobox
       pattern), so the hidden native select leaves the tab order. */
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cs__trigger';
    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-controls', listId);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span class="cs__value"></span>' + CHEVRON;

    var list = document.createElement('ul');
    list.className = 'cs__list';
    list.id = listId;
    list.setAttribute('role', 'listbox');

    if (label) {
      label.id = label.id || select.id + '-label';
      trigger.setAttribute('aria-labelledby', label.id);
      list.setAttribute('aria-labelledby', label.id);
    }

    function choose(i) {
      var opt = select.options[i];
      if (!opt || opt.disabled) return;
      select.selectedIndex = i;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      paint();
    }

    function setActive(i) {
      var items = list.children;
      if (items[active]) items[active].classList.remove('cs__option--active');
      active = i;
      if (!items[i]) return trigger.removeAttribute('aria-activedescendant');
      items[i].classList.add('cs__option--active');
      items[i].scrollIntoView({ block: 'nearest' });
      trigger.setAttribute('aria-activedescendant', items[i].id);
    }

    /* next enabled option after `from` in direction `dir`, or `from` when there is none */
    function step(from, dir) {
      for (var i = from + dir; i >= 0 && i < select.options.length; i += dir) {
        if (!select.options[i].disabled) return i;
      }
      return from;
    }

    function paint() {
      var sel = select.options[select.selectedIndex];
      trigger.querySelector('.cs__value').textContent = sel ? sel.text : '';
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt, i) {
        var li = document.createElement('li');
        li.className = 'cs__option';
        li.id = listId + '-' + i;
        li.setAttribute('role', 'option');
        li.textContent = opt.text;
        if (opt.disabled) li.setAttribute('aria-disabled', 'true');
        if (i === select.selectedIndex) li.setAttribute('aria-selected', 'true');
        li.addEventListener('click', function () {
          choose(i);
        });
        list.appendChild(li);
      });
    }

    function open() {
      wrap.classList.add('cs--open');
      trigger.setAttribute('aria-expanded', 'true');
      setActive(select.selectedIndex);
    }
    function close() {
      wrap.classList.remove('cs--open');
      trigger.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      wrap.classList.contains('cs--open') ? close() : open();
    });
    trigger.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Tab') return close();
      if (!wrap.classList.contains('cs--open')) {
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') {
          e.preventDefault();
          open();
        }
        return;
      }
      if (k === 'ArrowDown') setActive(step(active, 1));
      else if (k === 'ArrowUp') setActive(step(active, -1));
      else if (k === 'Home') setActive(step(-1, 1));
      else if (k === 'End') setActive(step(select.options.length, -1));
      else if (k === 'Enter' || k === ' ') choose(active);
      else return;
      e.preventDefault();
    });
    /* Firefox fires the button click on Space keyup, which would toggle the list again */
    trigger.addEventListener('keyup', function (e) {
      if (e.key === ' ') e.preventDefault();
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    /* keep the trigger label in sync when Dawn changes the variant elsewhere */
    select.addEventListener('change', paint);

    wrap.appendChild(trigger);
    wrap.appendChild(list);
    paint();
  }

  function init() {
    document
      .querySelectorAll('.product--shop variant-selects .select__select')
      .forEach(enhance);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
